module.exports = __webpack_public_path__ + "media/photo/Group300-f941c553.png";